require('./spinner.component.scss');

class SpinnerController {
  constructor() {
  }
}

export const SpinnerComponent = {
  template  : require('./spinner.component.html'),
  bindings  : {
  },
  controller: SpinnerController,
};



// WEBPACK FOOTER //
// ./src/shared/spinner.component.js